import HymnContentFromService from "./HymnContentFromService";

// The shared reader narrows to the route's hymnId when present, retaining all
// ordered alternatives of the selected format in either view.
export default HymnContentFromService;
